import React from 'react';
import PropTypes from 'prop-types';
import CreatedAtFilter from 'components/form/filters/CreatedAtFilter';
import MonthFilter from 'components/list/Filters/types/MonthFilter';
import ResourceFilter from 'components/list/Filters/ResourceFilter';
import SelectField from 'components/input/SelectField/SelectField';
import UserIdFilter from 'components/form/filters/UserIdFilter';
import {
    STATUS_CHARGED_BACK,
    STATUS_OPEN,
    STATUS_OVERDUE,
    STATUS_PAID,
    STATUS_PAID_MANUALLY,
} from 'pages/invoices/show/InvoiceStatus';
import filterMatchTypes from 'components/list/Filters/filterMatchTypes';
import TextToArrayFilter from 'components/list/Filters/types/TextToArrayFilter';
import SubCategoryIdFilter from 'components/form/filters/SubCategoryIdFilter';

const InvoiceIdFilter = <TextToArrayFilter
    label='resources.products.fields.id'
    options={ {
        fullWidth: true,
    } }
    source='id'
/>;

const InvoicesListFilters = (props) => {
    const filters = {
        basic: {
            invoiced_at: {
                component: React.createElement(MonthFilter, {
                    label: 'resources.invoices.fields.invoiced_at',
                    source: 'invoiced_at',
                }),
                matchTypes: {
                    values: [
                        filterMatchTypes.equals,
                    ],
                },
            },
            status: {
                component: React.createElement(SelectField, {
                    choices: [
                        {
                            id: STATUS_OPEN,
                            name: 'resources.invoices.status.open',
                        },
                        {
                            id: STATUS_OVERDUE,
                            name: 'resources.invoices.status.overdue',
                        },
                        {
                            id: STATUS_PAID,
                            name: 'resources.invoices.status.paid',
                        },
                        {
                            id: STATUS_PAID_MANUALLY,
                            name: 'resources.invoices.status.paid_manually',
                        },
                        {
                            id: STATUS_CHARGED_BACK,
                            name: 'resources.invoices.status.charged_back',
                        },
                    ],
                    floatingLabelFixed: true,
                    label: 'resources.invoices.fields.status',
                    source: 'status',
                }),
                matchTypes: {
                    values: [
                        filterMatchTypes.equals,
                    ],
                },
            },
            user_id: {
                component: UserIdFilter,
                matchTypes: {
                    values: [
                        filterMatchTypes.equals,
                    ],
                },
            },
        },
        advanced: {
            created_at: {
                component: CreatedAtFilter,
                matchTypes: {
                    values: [
                        filterMatchTypes.between,
                    ],
                },
            },
            id: {
                component: InvoiceIdFilter,
                matchTypes: {
                    default: filterMatchTypes.equals,
                    values: [
                        filterMatchTypes.equals,
                    ],
                },
            },
            subcategory_id: {
                component: SubCategoryIdFilter,
                matchTypes: {
                    default: filterMatchTypes.matchOneOf,
                    values: [
                        filterMatchTypes.matchOneOf,
                    ],
                },
            },
            user_id: {
                component: UserIdFilter,
                matchTypes: {
                    default: filterMatchTypes.equals,
                    values: [
                        filterMatchTypes.equals,
                    ],
                },
            },
        },
    };

    return (
        <ResourceFilter
            { ...props }
            filters={ filters }
        />
    );
};

InvoicesListFilters.propTypes = {
    actionType: PropTypes.string.isRequired,
    location: PropTypes.object,
    resource: PropTypes.string,
};

export default InvoicesListFilters;


// WEBPACK FOOTER //
// ./src/pages/invoices/list/InvoicesListFilters.js